import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SideNavButton } from './SideNavButton';
import { navigateToHelpScreen } from './navigateToHelpScreen';

export const HelpButton = () => {
  const location = useLocation();

  // Global F1 shortcut to open Help with route-derived context when available.
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key !== 'F1') return;

      event.preventDefault();
      const contextMatch = location.pathname.match(/^\/[^/]+\/([^/]+)/);
      const context = contextMatch ? contextMatch[1] : null;
      navigateToHelpScreen(context);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [location.pathname]);

  return (
    <SideNavButton 
      onClick={navigateToHelpScreen} 
      icon={<FontAwesomeIcon icon={fas.faCircleQuestion} size="2x" />}
    />
  )
}